/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_TitleInputs */

const en_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL Export`)
};

const fr_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation CCSL`)
};

const de_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL-Export`)
};

const it_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione CCSL`)
};

const ru_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт CCSL`)
};

const es_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación CCSL`)
};

const zh_cn2_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL出口`)
};

const ja_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSLエクスポート`)
};

const hi_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीसीएसएल निर्यात`)
};

const pt_pt2_ccsl_export_title = /** @type {(inputs: Ccsl_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação CCSL`)
};

/**
* | output |
* | --- |
* | "CCSL Export" |
*
* @param {Ccsl_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_title = /** @type {((inputs?: Ccsl_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_title(inputs)
	if (locale === "de") return de_ccsl_export_title(inputs)
	if (locale === "it") return it_ccsl_export_title(inputs)
	if (locale === "ru") return ru_ccsl_export_title(inputs)
	if (locale === "es") return es_ccsl_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_title(inputs)
	if (locale === "ja") return ja_ccsl_export_title(inputs)
	if (locale === "hi") return hi_ccsl_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_title(inputs)
	return en_ccsl_export_title(inputs)
});